import { apiClient } from "../config";

async function archiveOrRestoreBrand(id: any, status: any) {
  const url = `/admin/brands/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreBrand;
